module.exports = __webpack_public_path__ + "static/homepage-mobile-96981bb2e5076c4d27a803b6bbfc872f.jpg";